import AdapterConfig from './utils/AdapterConfig';
import TraceInit from './TraceInit';

// 直接进行数据的上报，兼容组件库的使用
export const traceVisible = (params) => {
  const {
    traceId = '',
    traceData = {},
    scmv2,
    pageName,
    statSend = {
      getParam: () => ({ spm: '' }),
      visible: () => {},
      touch: () => {},
      view: () => {},
    },
  } = params;
  const operation = AdapterConfig.getTraceOperation(traceId);

  if (operation?.includes('visible')) {
    const parsedData = AdapterConfig.getTraceData(pageName, traceId, {
      traceData,
      type: 'visible',
    });
    const { b, c, d, iid } = parsedData;
    const spm = AdapterConfig.getSpm(statSend, { b, c, d });

    if (TraceInit.getInstance().isSpm) {
      statSend && statSend.visible(c, iid, { spm, scmv2 });
    } else {
      statSend && statSend.visible(parsedData);
    }
  }
};

export const traceTouch = (params) => {
  const {
    traceId = '',
    traceData = {},
    scmv2,
    pageName,
    statSend = {
      getParam: () => ({ spm: '' }),
      visible: () => {},
      touch: () => {},
      view: () => {},
    },
  } = params;
  const operation = AdapterConfig.getTraceOperation(traceId);

  if (operation?.includes('touch')) {
    const parsedData = AdapterConfig.getTraceData(pageName, traceId, {
      traceData,
      type: 'touch',
    });
    const { b, c, d, iid } = parsedData;
    const spm = AdapterConfig.getSpm(statSend, { b, c, d }, true);

    if (TraceInit.getInstance().isSpm) {
      if (process.env && process.env.MIX_ENV === 'mini') {
        let touchTimer = setTimeout(() => {
          touchTimer = null;
          clearTimeout(touchTimer);
          statSend && statSend.touch(c, iid, { spm, scmv2 });
        }, 1000);
      } else {
        statSend && statSend.touch(c, iid, { spm, scmv2 });
      }
    } else {
      statSend && statSend.touch(parsedData);
    }
    return spm;
  }
  return '';
};
